var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66043 6.97147V2.48605C8.66043 1.93377 8.24068 1.48605 7.72293 1.48605H7.66943C7.15168 1.48605 6.73193 1.93377 6.73193 2.48605V6.97147H2.52686C2.00909 6.97147 1.58936 7.41921 1.58936 7.97147V8.02854C1.58936 8.58081 2.00909 9.02854 2.52686 9.02854H6.73193V13.5139C6.73193 14.0662 7.15168 14.5139 7.66943 14.5139H7.72293C8.24068 14.5139 8.66043 14.0662 8.66043 13.5139V9.02854H12.8655C13.3833 9.02854 13.803 8.58081 13.803 8.02854V7.97147C13.803 7.41921 13.3833 6.97147 12.8655 6.97147H8.66043Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.8af4ddeab31432c9f043119dd7069624.svg";
export { ForwardRef as ReactComponent };